// Canonical labor category order. priceTakeoff's group output order depends on this.
export const LABOR_CATEGORY_KEYS = ['mtc', 'arborist', 'herbicide', 'irrigation', 'operator', 'craneOperator'];
